/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

const csmOmnichannelCustomerMatchSuggestionsEnabled = {
	get(): boolean {
		return fg('csm_omnichannel_customer_match_suggestions');
	},
};

export default csmOmnichannelCustomerMatchSuggestionsEnabled;
